import { motion } from "framer-motion";
import { BadgeCheck, Building2, Check, MapPin } from "lucide-react";
import { ASSETS, BRAND } from "@/data/content";
import CtaBand from "@/components/CtaBand";

const PILLARS = [
  ["Goal-first planning", "Products nahi, pehle aapke goals. Phir unke hisaab se plan."],
  ["Transparent guidance", "Charges, risks aur process — sab kuch saaf-saaf bataya jata hai."],
  ["Local trust", "Bindki-Fatehpur ka apna advisor. Office par aakar mil sakte hain."],
  ["One point of contact", "Insurance, tax, CSC — har kaam ke liye ek hi bharosemand number."],
];

export default function About() {
  return (
    <>
      <section className="page-hero" data-testid="about-hero">
        <div className="eyebrow gold">Meet Utkarsh Gupta</div>
        <h1>About <span className="accent">Us</span></h1>
        <p>Bindki ka apna financial partner — insurance, investment, tax aur digital services ke liye ek bharosemand naam.</p>
      </section>
      <section className="section about-teaser">
        <div className="about-image">
          <img src={ASSETS.profile} alt="Utkarsh Gupta, founder Bima Bachat Bazar" />
          <div className="image-caption"><strong>{BRAND.advisor}</strong><span>Corporate Investment Consultant</span></div>
        </div>
        <motion.div className="about-copy" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="eyebrow gold">The story</div>
          <h2>"{BRAND.tagline}"</h2>
          <p className="lead">Bima Bachat Bazar ki shuruaat ek simple soch se hui — har family ko sahi financial salah mile, bina bade shehar jaaye.</p>
          <p>Aaj hum insurance (Policybazaar, SBI Life, Turtlemint), mutual funds (NJ Wealth, ZFunds, SBI MF), stock broking (Angel One, INDmoney) aur CSC digital services — sab kuch ek hi chatrachhaya ke neeche dete hain. Hamara maqsad sirf product bechna nahi, balki aapke poore financial life ka saathi banna hai.</p>
          <div className="check-list">
            <span><BadgeCheck size={15} /> Authorised partner — 11 official platforms</span>
            <span><BadgeCheck size={15} /> Bindki mein physical office</span>
            <span><BadgeCheck size={15} /> WhatsApp par fast response</span>
          </div>
        </motion.div>
      </section>
      <section className="section section-light">
        <div className="section-head centered">
          <div className="eyebrow blue">Why choose Bima Bachat Bazar?</div>
          <h2>Trust pillars, <span className="accent">not just promises.</span></h2>
        </div>
        <div className="pillar-grid">
          {PILLARS.map(([title, text], i) => (
            <motion.article className="pillar-card" key={title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }} data-testid={`pillar-card-${i}`}>
              <span className="chapter-no">0{i + 1}</span>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </section>
      <section className="section office-section" data-testid="office-section">
        <div className="office-card">
          <Building2 size={28} />
          <div>
            <h3>Visit our office</h3>
            <p><MapPin size={14} /> {BRAND.address}</p>
            <div className="check-list">
              <span><Check size={14} /> Phone: {BRAND.phone1} / {BRAND.phone2}</span>
              <span><Check size={14} /> Email: {BRAND.email}</span>
            </div>
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
